import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Table, Modal, notification, Tag } from "antd";
import LicensesService from "../services/licenses.service";
import { useParams } from "react-router-dom";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { confirm } = Modal;

function TableViewLog() {
  const { id } = useParams();

  const columnLicense = [
    {
      title: "Line Name",
      dataIndex: "LineName",
      key: "line_name",
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "type",
    },
    {
      title: "Used",
      dataIndex: "Used",
      key: "used",
      
    },
    {
        title: "Created Date",
        dataIndex: "CreateAt",
        key: "create_date",
        render: (text) => (
          <span>{moment(text).format("DD MMMM YYYY, hh:mm:ss a")}</span>
        ),
      }
  ];
  // state column
  const [columns, setColumns] = useState(columnLicense);

  // state table
  const [licensesLog, setLicensesLog] = useState([]);
 
  // const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  // fetch data
// fetch data
  const fetch = async (id) => {
    try {
      setLoading(true);
      const ret = await LicensesService.getLicensesById(id);

      if (ret.status !== 200) {
        throw { message: ret.data.message };
      }

      const data = ret.data;

      setLicensesLog(Array.isArray(data) ? data : [data]);
      setColumns(columnLicense);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching license:", error);
      notification.error({
        message: "Error",
        description: error.message || "Cannot fetch license",
      });
    }
  };

  useEffect(() => {
    if (id) {
      console.log("Fetching license id:", id);
      fetch(id);
    }
  }, [id]);

  return (
    <>
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={licensesLog}
        // pagination={pagination}
        loading={loading}
        // onChange={handleTableChange}
        scroll={false}
        className="table-row-pointer"
      />
    </>
  );
}

export default TableViewLog;